import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

type MessageStatusProps = {
  status: 'sent' | 'delivered' | 'read';
  className?: string;
};

export const MessageStatus: React.FC<MessageStatusProps> = ({
  status,
  className,
}) => {
  if (status === 'sent') {
    // Single tick for sent
    return (
      <div className={cn("inline-flex items-center", className)}>
        <Check className="h-2.5 w-2.5" strokeWidth={2.5} />
      </div>
    );
  } else if (status === 'delivered') {
    // Double ticks for delivered
    return (
      <div className={cn("inline-flex items-center", className)}>
        <div className="relative">
          <Check className="h-2.5 w-2.5" strokeWidth={2.5} />
          <Check className="h-2.5 w-2.5 absolute -left-1 top-0" strokeWidth={2.5} />
        </div>
      </div>
    );
  } else if (status === 'read') {
    // Double blue ticks for read
    return (
      <div className={cn("inline-flex items-center", className)}>
        <div className="relative">
          <Check className="h-2.5 w-2.5" strokeWidth={2.5} />
          <Check className="h-2.5 w-2.5 absolute -left-1 top-0" strokeWidth={2.5} />
        </div>
      </div>
    );
  }

  // Default case or undefined status
  return null;
};
